<template>
<div>
  <div class="input input-margin">
    <div class="icon"><img src="../../assets/image/phone.png" /></div>
    <input v-model="peopleForm.account" autocomplete="off" type="tel" placeholder="请输入手机号码" />
    <span class="min-btn del-phone" v-show="peopleForm.account" @click="peopleForm.account=''"></span>
  </div>
  <div class="clearfix send-code input-margin">
    <div class="input fl">
      <div class="icon"><img src="../../assets/image/code.png" /></div>
      <input v-model="peopleForm.verifyCode" autocomplete="off" type="tel" placeholder="请输入验证码" />
    </div>
    <div class="fr right-btn" :class="{'sending':sending}" @click="sendCode">
      {{sending ? time+'s后再获取' : '发送验证码'}}
    </div>
  </div>
  <div class="input input-margin">
    <div class="icon"><img src="../../assets/image/lack.png" /></div>
    <input v-model="peopleForm.password" autocomplete="off" :type="passType" placeholder="请输入密码:8-20位,包含大小写字母、数字和特殊符号" />
    <span class="min-btn show-pass" :class="{'close-eye':passType === 'password'}" @click="changePass"></span>
  </div>
  <div class="form-item clearfix input-margin">
    <div class="left-label fl">姓名：</div>
    <div class="input right-cont fr">
      <input v-model="peopleForm.name" type="text" placeholder="请输入姓名" />
    </div>
  </div>
  <div class="form-item clearfix input-margin">
    <div class="left-label fl">学校地址：</div>
    <div class="right-cont fr">
      <city-select @change-data="citySelected" :isZj="isZhejiang"></city-select>
    </div>
  </div>
  <div class="form-item clearfix input-margin">
    <div class="left-label fl">学校：</div>
    <div class="right-cont fr">
      <Select v-model="peopleForm.schoolId" class="school-select">
        <Option v-for="item in schoolList" :value="item.id" :key="item.id">{{ item.name }}</Option>
        <Option :value="0">其他</Option>
      </Select>
    </div>
  </div>
  <div class="form-item clearfix input-margin" v-show="peopleForm.schoolId === 0">
    <div class="left-label fl">学校名称：</div>
    <div class="input right-cont fr">
      <input v-model="peopleForm.schoolName" type="text" placeholder="请输入学校名称" />
    </div>
  </div>
  <div class="form-item clearfix input-margin" v-show="peopleForm.schoolId === 0">
    <div class="left-label fl"></div>
    <div class="input right-cont fr">
      <input v-model="peopleForm.schoolAddress" type="text" placeholder="请输入详细地址" />
    </div>
  </div>
  <div class="form-item clearfix">
    <div class="left-label fl">职位：</div>
    <div class="input right-cont fr">
      <input v-model="peopleForm.profession" type="text" placeholder="请输入职位" />
    </div>
  </div>
  <div class="form-item clearfix" style="margin-bottom: 10px;">
    <div class="left-label fl"></div>
    <div class="right-cont fr">
      <span style="color: #FF3B30;font-size: 14px;" v-show="errorString">*{{errorString}}</span>
    </div>
  </div>
  <div class="large-btn" @click="goTo">注册</div>
</div>
</template>

<script>
/* eslint-disable */
// import stemSelect from '../../components/select/select.vue';
import citySelect from '../../components/citySelect/index';
import utils, {
  pwdCheckUtil
} from '../../utils/index';
const {
  apis,
  $
} = utils;
export default {
  name: 'register',
  data() {
    return {
      peopleForm: {
        account: '',
        verifyCode: '',
        password: '',
        name: '',
        provinceId: null,
        cityId: null,
        districtId: null,
        schoolId: null
      },
      isZhejiang: true,
      passType: 'password',
      sending: false,
      time: 60,
      schoolList: [],
      errorString: '',
      cityArr: []
    }
  },
  created() {},
  watch: {},
  methods: {
    sendCode() {
      if (this.sending) {
        return false;
      }
      if (!this.peopleForm.account) {
        this.errorString = '请输入手机号码！';
        return false
      } else {
        this.errorString = '';
      }
      this.sending = true;
      $.post(apis.msgSend, {
        mobile: this.peopleForm.account
      }).then(res => {
        if (res.code === 0) {
          this.time = 60;
          let timer = setInterval(() => {
            this.time--;
            if (this.time === 0) {
              clearInterval(timer);
              this.sending = false;
            }
          }, 1000);
          this.isZhejiang = res.isZhejiang;
        } else {
          this.errorString = res.msg;
          this.sending = false;
        }
      });
    },
    changePass() {
      this.passType = this.passType === 'password' ? 'text' : 'password';
    },
    goTo() {
      let errorString = '';
      let peopleForm = JSON.parse(JSON.stringify(this.peopleForm));
      if (!peopleForm.account) {
        errorString = '请输入手机号码！';
      } else if (!peopleForm.verifyCode) {
        errorString = '请输入验证码！';
      } else if (!peopleForm.password) {
        errorString = '请输入密码！';
      } else if (!peopleForm.name) {
        errorString = '请输入姓名！';
      } else if (peopleForm.schoolId === 0 && !peopleForm.schoolName) {
        errorString = '请输入学校名称！';
      } else if (peopleForm.schoolId == null) {
        errorString = '请选择学校！';
      } else {
        errorString = '';
      }
      this.errorString = errorString;
      if (errorString) {
        return false;
      }
      if (peopleForm.schoolId === 0) {
        delete peopleForm.schoolId;
      }
      let cityArr = this.cityArr;
      // 省市区
      if (cityArr.length === 3) {
        peopleForm.provinceId = cityArr[0];
        peopleForm.cityId = cityArr[1];
        peopleForm.districtId = cityArr[2];
      }

      if (!pwdCheckUtil(this.peopleForm.password)) {
        this.$Message.error('密码不符合要求');
        return false
      }

      $.post(apis.register, peopleForm).then(res => {
        if (res.code === 0) {
          this.$Message.success('注册成功！');
          this.$router.push('/login');
        } else {
          this.errorString = res.msg;
        }
      });

    },
    citySelected(value) {
      if (value.length === 1 && value[0] === 0) {
        this.peopleForm.schoolId = 0;
        this.schoolList = [];
        this.cityArr = [];
      } else {
        this.getSchool(value[2]);
        this.cityArr = value;
        this.peopleForm.schoolId = null;
      }
    },
    getSchool(id) {
      $.post(apis.getSchool, {
        id: id
      }).then(res => {
        let list = res.list || [];
        this.schoolList = list;
      })
    }
  },
  components: {
    citySelect
  }
}
</script>

<style lang="scss" scoped>
@import "./style/login.scss";
</style>
